import { Button } from '@mantine/core'
import { noop } from 'lodash'
import React, { SyntheticEvent } from 'react'
import styled from 'styled-components'

import Icon from '../Icon'

const Wrapper = styled.div``

type TAddButton = {
  onAdd?: (e: SyntheticEvent) => void
  children?: React.ReactNode
  label?: string
  style?: any
}

const AddButton = (props: TAddButton): React.ReactElement => {
  const { onAdd = noop, children, label, style } = props

  return (
    <Wrapper style={style}>
      <div className="py-2">
        <Button variant="subtle" onClick={onAdd} color="blue">
          <Icon icon="far fa-plus" className="mr-1" />{' '}
          {children ||
            label ||
            i18n.t('add_new_element', 'Neues Element hinzufügen')}
        </Button>
      </div>
      {/* <div className="m-1 mt-2">
        <span
          className="text-primary"
          style={{ cursor: 'pointer' }}
          onClick={onAdd}
        >
          <Icon icon="far fa-plus" />{' '}
          {children ||
            label ||
            i18n.t('add_new_element', 'Neues Element hinzufügen')}
        </span>
      </div> */}
    </Wrapper>
  )
}

export default AddButton
